import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { DesktopRightSidebar } from 'shared/components/BannerAll';
import cx from 'classnames';
import { Googletag } from 'shared/modules';
import SeoTexts from 'shared/components/SeoTexts/SeoTexts';
import { generateFirmsSearchUrl, generateSearchQuery } from 'shared/helpers/urls';
import { toLocalized } from 'shared/helpers/locale';
import InlineNav from 'desktop/components/InlineNav/InlineNav';
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import PageTitle from 'desktop/components/PageTitle/PageTitle';
import Paginate from 'desktop/components/Paginate/Paginate';
import { injectIntl, intlShape } from 'react-intl';
import SearchFirms from 'desktop/components/SearchPanel/SearchFirms';
import history from 'history.js';
import FirmList from './components/FirmList';

import s from './Firms.css';

const PER_PAGE = 20;
class Firms extends React.Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    query: PropTypes.shape().isRequired,
    currentPage: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    globals: PropTypes.shape(),
    formResults: PropTypes.shape().isRequired,
    metaHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    intl: intlShape.isRequired,
    currentPath: PropTypes.string,
  };

  static defaultProps = {
    topFirm: null,
    globals: {},
    companyTypes: null,
    currentPath: '/katalog-kompaniy/sto/',
    currentType: null,
  };
  handleSearchSubmit = query => {
    const basePath = `/${generateFirmsSearchUrl({})}`;
    const searchPath = `${basePath}?${queryString.stringify(generateSearchQuery({ query }))}`;

    history.push(toLocalized(searchPath, this.props.locale));
  };
  render() {
    const {
      url,
      query,
      currentPage,
      formResults,
      metaHeader,
      currentPath,
      intl,
      globals,
    } = this.props;
    let { location } = globals;

    location = location ? `${location.slug}/` : '';
    const navLinks = [
      {
        route: `/katalog-kompaniy/sto/${location}`,
        slug: 'sto',
        title: intl.formatMessage({ id: 'сто' }).toUpperCase(),
      },
      {
        route: `/katalog-kompaniy/avtorazborka/${location}`,
        slug: 'avtorazborka',
        title: intl.formatMessage({ id: 'авторазборка' }).toUpperCase(),
      },
      {
        route: `/katalog-kompaniy/avtovykup/${location}`,
        slug: 'avtovykup',
        title: intl.formatMessage({ id: 'Автовыкуп' }).toUpperCase(),
      },
      {
        route: `/katalog-kompaniy/zapchasti/${location}`,
        slug: 'zapchasti',
        title: intl.formatMessage({ id: 'Запчасти' }).toUpperCase(),
      },
      {
        route: `/katalog-kompaniy/avtotovary/${location}`,
        slug: 'avtotovary',
        title: intl.formatMessage({ id: 'Автотовары' }).toUpperCase(),
      },
      {
        route: `/katalog-kompaniy/teritorialni-servisni-centri/${location}`,
        slug: 'teritorialni-servisni-centri',
        title: intl.formatMessage({ id: 'тсц' }).toUpperCase(),
      },
    ];
    const result = formResults.firms;
    const firms = result && result.results;
    const pageCount = result ? Math.ceil(result.count / PER_PAGE) : 1;
    return (
      <div className={s.page}>
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={cx(s.flexCell, s.mainCell)}>
              <div className={s.navWrapper}>
                <InlineNav currentRoute={currentPath} navLinks={navLinks} including />
              </div>
              <SearchFirms />
              <div className={s.advertContainerGl}>
                <Googletag id="div-gpt-ad-1510239331518-2" />
              </div>
              <PageTitle title={metaHeader} />
              <FirmList firms={firms} url={'/katalog-kompaniy/'} />
              {pageCount > 1 && (
                <Paginate url={url} query={query} pageCount={pageCount} initialPage={currentPage} />
              )}
              <SeoTexts currentPath={currentPath} />
            </div>
            <DesktopRightSidebar>
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ searchForm, globals, history: historyPath }) => ({
  formState: searchForm && searchForm.selected,
  formResults: searchForm && searchForm.results,
  formData: searchForm && searchForm.data,
  formVocabulary: searchForm && searchForm.vocabulary,
  //
  currentPath: historyPath && historyPath.currentPath,
  counts: searchForm && searchForm.counts,
  globals,
});
const mapDispatchToProps = dispatch => ({
  dispatch,
});
export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(injectIntl(Firms)),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/firms/Firms.js